import { IdentityService } from 'api/generated/services/IdentityService';
import { UseMutationOptions, useMutation } from 'react-query';

export const useIdentityUsersTwoFactorSendMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof IdentityService.postIdentityUsersTwoFactorSend>>,
      unknown,
      {
        userId: number;
      },
      unknown
    >,
    'mutationFn'
  >
) => useMutation(({ userId: userId }) => IdentityService.postIdentityUsersTwoFactorSend(userId), options);
